import {
	AlertCircle,
	AlignCenter,
	AlignJustify,
	AlignLeft,
	AlignRight,
	ArrowDown,
	ArrowDownToLine,
	ArrowLeft,
	ArrowLeftRight,
	ArrowRight,
	ArrowUp,
	ArrowUpDown,
	Ban,
	BarChart3,
	Bandage,
	Bell,
	BellOff,
	Bold,
	BookOpen,
	Book,
	Bookmark,
	Bot,
	Braces,
	Brain,
	Briefcase,
	Building,
	Building2,
	Calendar,
	CalendarDays,
	CalendarPlus,
	CalendarSync,
	CalendarX,
	Check,
	CheckCircle,
	CheckCircle2,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
	ChevronsUpDown,
	Circle,
	CircleHelp,
	ClipboardCheck,
	ClipboardList,
	Clock,
	Clock3,
	Cloud,
	Coins,
	Columns,
	Copy,
	CornerDownLeft,
	CreditCard,
	Dot,
	Download,
	Edit,
	EllipsisVertical,
	ExternalLink,
	Eye,
	EyeOff,
	File,
	FileCheck,
	FileDown,
	FilePlus,
	FileSearch,
	FileText,
	FileUp,
	Files,
	Filter,
	Folder,
	FolderKanban,
	FolderOpen,
	FolderPlus,
	FolderSync,
	GalleryVerticalEnd,
	Gavel,
	Globe,
	HardHat,
	Hash,
	Heart,
	HelpCircle,
	History,
	Home,
	Image,
	Inbox,
	IndentDecrease,
	IndentIncrease,
	Info,
	Italic,
	Key,
	Landmark,
	Languages,
	Library,
	LayoutGrid,
	Link,
	Link2,
	List,
	Loader,
	Loader2,
	Lock,
	LogOut,
	Mail,
	Maximize2,
	Menu,
	MessageCircle,
	MessageSquare,
	MessageSquarePlus,
	MessageSquareText,
	MessageSquareX,
	Mic,
	Minimize2,
	Monitor,
	MonitorSmartphone,
	MoreHorizontal,
	Package,
	PanelLeft,
	PanelRight,
	Paperclip,
	Pause,
	PenLine,
	PenTool,
	Pencil,
	Phone,
	PieChart,
	Plane,
	Play,
	PlayCircle,
	Plus,
	Quote,
	Receipt,
	RefreshCw,
	Replace,
	Reply,
	RotateCcw,
	RotateCw,
	Redo,
	Redo2,
	Ruler,
	Scale,
	ScrollText,
	Search,
	Send,
	Settings,
	Settings2,
	Share2,
	Shield,
	ShieldCheck,
	ShieldX,
	ShoppingCart,
	Signature,
	SlidersHorizontal,
	Sparkles,
	Square,
	Tag,
	Table,
	ThumbsDown,
	ThumbsUp,
	Timer,
	Trash2,
	TriangleAlert,
	Type,
	Underline,
	Unlink,
	Undo,
	Undo2,
	Upload,
	User,
	UserCheck,
	UserPlus,
	UserX,
	Users,
	Users2,
	Video,
	Volume2,
	VolumeX,
	Wallet,
	Wand2,
	Wrench,
	ZoomIn,
	ZoomOut,
	X,
	XCircle,
} from "lucide-react";

// Add a new icon here. A caller then names the icon and imports nothing from lucide.
export const lucideRegistry = {
	"alert-circle": AlertCircle,
	"align-center": AlignCenter,
	"align-justify": AlignJustify,
	"align-left": AlignLeft,
	"align-right": AlignRight,
	"arrow-down": ArrowDown,
	"arrow-down-to-line": ArrowDownToLine,
	"arrow-left": ArrowLeft,
	"arrow-left-right": ArrowLeftRight,
	"arrow-right": ArrowRight,
	"arrow-up": ArrowUp,
	"arrow-up-down": ArrowUpDown,
	ban: Ban,
	"bar-chart": BarChart3,
	bandage: Bandage,
	bell: Bell,
	"bell-off": BellOff,
	bold: Bold,
	"book-open": BookOpen,
	book: Book,
	bookmark: Bookmark,
	bot: Bot,
	braces: Braces,
	brain: Brain,
	briefcase: Briefcase,
	building: Building,
	building2: Building2,
	calendar: Calendar,
	"calendar-days": CalendarDays,
	"calendar-plus": CalendarPlus,
	"calendar-sync": CalendarSync,
	"calendar-x": CalendarX,
	check: Check,
	"check-circle": CheckCircle,
	"check-circle2": CheckCircle2,
	"chevron-down": ChevronDown,
	"chevron-left": ChevronLeft,
	"chevron-right": ChevronRight,
	"chevron-up": ChevronUp,
	"chevrons-up-down": ChevronsUpDown,
	circle: Circle,
	"circle-help": CircleHelp,
	"clipboard-check": ClipboardCheck,
	"clipboard-list": ClipboardList,
	clock: Clock,
	"clock-3": Clock3,
	cloud: Cloud,
	coins: Coins,
	columns: Columns,
	copy: Copy,
	"corner-down-left": CornerDownLeft,
	"credit-card": CreditCard,
	dot: Dot,
	download: Download,
	edit: Edit,
	"ellipsis-vertical": EllipsisVertical,
	"external-link": ExternalLink,
	eye: Eye,
	"eye-off": EyeOff,
	file: File,
	"file-check": FileCheck,
	"file-down": FileDown,
	"file-plus": FilePlus,
	"file-search": FileSearch,
	"file-text": FileText,
	"file-up": FileUp,
	files: Files,
	filter: Filter,
	folder: Folder,
	"folder-kanban": FolderKanban,
	"folder-open": FolderOpen,
	"folder-plus": FolderPlus,
	"folder-sync": FolderSync,
	"gallery-vertical-end": GalleryVerticalEnd,
	gavel: Gavel,
	globe: Globe,
	"hard-hat": HardHat,
	hash: Hash,
	heart: Heart,
	"help-circle": HelpCircle,
	history: History,
	home: Home,
	image: Image,
	inbox: Inbox,
	"indent-decrease": IndentDecrease,
	"indent-increase": IndentIncrease,
	info: Info,
	italic: Italic,
	key: Key,
	landmark: Landmark,
	languages: Languages,
	library: Library,
	"layout-grid": LayoutGrid,
	link: Link,
	link2: Link2,
	list: List,
	loader: Loader,
	loader2: Loader2,
	lock: Lock,
	"log-out": LogOut,
	mail: Mail,
	maximize2: Maximize2,
	menu: Menu,
	"message-circle": MessageCircle,
	"message-square": MessageSquare,
	"message-square-plus": MessageSquarePlus,
	"message-square-text": MessageSquareText,
	"message-square-x": MessageSquareX,
	mic: Mic,
	minimize2: Minimize2,
	monitor: Monitor,
	"monitor-smartphone": MonitorSmartphone,
	"more-horizontal": MoreHorizontal,
	package: Package,
	"panel-left": PanelLeft,
	"panel-right": PanelRight,
	paperclip: Paperclip,
	pause: Pause,
	"pen-line": PenLine,
	"pen-tool": PenTool,
	pencil: Pencil,
	phone: Phone,
	"pie-chart": PieChart,
	plane: Plane,
	play: Play,
	"play-circle": PlayCircle,
	plus: Plus,
	quote: Quote,
	receipt: Receipt,
	"refresh-cw": RefreshCw,
	replace: Replace,
	reply: Reply,
	"rotate-ccw": RotateCcw,
	"rotate-cw": RotateCw,
	redo: Redo,
	redo2: Redo2,
	ruler: Ruler,
	scale: Scale,
	"scroll-text": ScrollText,
	search: Search,
	send: Send,
	settings: Settings,
	settings2: Settings2,
	share2: Share2,
	shield: Shield,
	"shield-check": ShieldCheck,
	"shield-x": ShieldX,
	"shopping-cart": ShoppingCart,
	signature: Signature,
	"sliders-horizontal": SlidersHorizontal,
	sparkles: Sparkles,
	square: Square,
	tag: Tag,
	table: Table,
	"thumbs-down": ThumbsDown,
	"thumbs-up": ThumbsUp,
	timer: Timer,
	trash2: Trash2,
	"triangle-alert": TriangleAlert,
	type: Type,
	underline: Underline,
	unlink: Unlink,
	undo: Undo,
	undo2: Undo2,
	upload: Upload,
	user: User,
	"user-check": UserCheck,
	"user-plus": UserPlus,
	"user-x": UserX,
	users: Users,
	users2: Users2,
	video: Video,
	volume2: Volume2,
	"volume-x": VolumeX,
	wallet: Wallet,
	wand2: Wand2,
	wrench: Wrench,
	x: X,
	"x-circle": XCircle,
	"zoom-in": ZoomIn,
	"zoom-out": ZoomOut,
} as const;
